export default "__VITE_ASSET__ThCrltqD__"